export function moveWithSlider(parameters = {}) {
    const { numberOfOpenedCategories } = parameters;
    const documentsSlider = document.getElementById('documentsSlider');
    const categoryLists = document.querySelectorAll('.documentation__categoryList');
    const screenWidth = window.screen.width;

    if (categoryLists.length === 0 || null === documentsSlider) {
        return;
    }

    const categoryList = categoryLists[0];
    const categoryListWidthSize = categoryList.offsetWidth + parseInt(getStyle(categoryList).marginRight);

    if (categoryListWidthSize >= screenWidth) {
        documentsSlider.style.left = -(numberOfOpenedCategories * categoryListWidthSize) + 'px';
    } else {
        if (numberOfOpenedCategories >= 1) {
            documentsSlider.style.left = -(categoryListWidthSize) + 'px';
        } else if (numberOfOpenedCategories === 0) {
            documentsSlider.style.left = '0px';
        }
    }
}

export function isMobileView() {
    const categoryListWidth = getWidthOfCategoryList();
    const screenWidth = window.screen.width;

    if (categoryListWidth) {
        return categoryListWidth >= screenWidth;
    }

    return false;
}

export function setCategoryListCommonHeight() {
    const documentsSlider = document.getElementById('documentsSlider');
    const categoryLists = document.querySelectorAll('.documentation__categoryList');
    const defaultState = document.querySelector('.documentation__defaultState');
    let maxHeight = 0;

    if (categoryLists.length === 0 || null === documentsSlider || isMobileView()) {
        return;
    }

    const documentSliderLeft = parseInt(getStyle(documentsSlider).left);
    let numberOfHiddenCategories = documentSliderLeft / getWidthOfCategoryList();
    numberOfHiddenCategories = numberOfHiddenCategories < 0 ? numberOfHiddenCategories * -1 : numberOfHiddenCategories;

    for (let i = 0; i < categoryLists.length; ++i) {
        const categoryList = getStyle(categoryLists[i]);
        const categoryListHeight = parseInt(categoryList.height);
        if (categoryListHeight > maxHeight && (i + 1) > numberOfHiddenCategories) {
            maxHeight = categoryListHeight;
        }
    }
    if (maxHeight > 0) {
        for (let i = 0; i < categoryLists.length; ++i) {
            if ((i + 1) > numberOfHiddenCategories) {
                categoryLists[i].style.height = maxHeight + 'px';
            }
        }
        if (null !== defaultState) {
            defaultState.style.height = maxHeight + 'px';
        }
    } else {
        defaultState.style.height = '498px';
    }
}

export function setHeadline(title = '') {
    const h2 = document.querySelector('h2');
    if (null !== h2 && title.length) {
        h2.innerHTML = title;
    }
}

function getWidthOfCategoryList() {
    const categoryLists = document.querySelectorAll('.documentation__categoryList');
    const categoryList = categoryLists.length ? categoryLists[0] : null;

    if (null !== categoryList) {
        return categoryList.offsetWidth + parseInt(getStyle(categoryList).marginRight);
    }

    return 0;
}

function getStyle(element) {
    return element.currentStyle || window.getComputedStyle(element);
}



// WEBPACK FOOTER //
// ./src/components/download/helper/slider.js